module.exports = __webpack_public_path__ + "static/media/02_Referenz_5w-50_mobile-min-min.7c371de7.jpg";